import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import Location from "../../commoncomponents/location";
import { utcToReportDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import { formatTemperatureReading, temperatureReadingClass } from "../../../utils/temperature";

function VisitNewLog(props) {
  const visits = props.visits || [];
  const timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : "";
  const getVisitTypeClass = (visit) => {
    if (visit.isOvernight) return "overnight";
    if (visit.isCurrent) return "current";
    if ((visit.visitType || "").toLowerCase().indexOf("virtual") >= 0) return "virtual";
    return "parked";
  };

  const data = (
    <Table striped responsive>
      <thead>
        <tr className="nowwrapTH">
          <th>Stop #</th>
          <th>Stop Type</th>
          <th>Arrived</th>
          <th>Departed</th>
          <th>Stop Duration</th>
          <th>Location</th>
          <th>Fridge</th>
          {props.tempAEnabled && <th>Temp A</th>}
          {props.tempBEnabled && <th>Temp B</th>}
          {props.driverIDEnabled && <th>Driver</th>}
        </tr>
      </thead>
      <tbody>
        {visits.map((visit) => (
          <tr
            key={`${visit.visitNumber}-${visit.arrived}`}
            className={`${visit.isInDepot ? "report-depot-row" : ""} ${String(props.selectedItemId) === String(visit.visitNumber) ? "report-row-selected" : ""}`.trim()}
            onClick={() => props.onItemSelect && props.onItemSelect(visit.visitNumber)}
            tabIndex="0"
            onKeyDown={(event) => event.key === "Enter" && props.onItemSelect && props.onItemSelect(visit.visitNumber)}
          >
            <td>{visit.visitNumber}</td>
            <td><span className={`visit-type-pill ${getVisitTypeClass(visit)}`}>{visit.visitType}</span></td>
            <td>{utcToReportDate(visit.arrived)}</td>
            <td>{visit.isCurrent ? "Current" : visit.isOvernight ? "After midnight" : utcToReportDate(visit.departed)}</td>
            <td>{visit.isOvernight ? "—" : visit.isCurrent || !visit.duration ? "In progress" : visit.duration}</td>
            <td><Location address={visit.address} lat={visit.latitude} lng={visit.longitude} />{visit.isInDepot && <span className="report-depot-badge">Depot</span>}</td>
            <td>{visit.fridge ? "On" : "Off"}</td>
            {props.tempAEnabled && <td className={temperatureReadingClass(visit.tempA)}>{formatTemperatureReading(visit.tempA)}</td>}
            {props.tempBEnabled && <td className={temperatureReadingClass(visit.tempB)}>{formatTemperatureReading(visit.tempB)}</td>}
            {props.driverIDEnabled && <td>{visit.driverName || visit.driverId || "-"}</td>}
          </tr>
        ))}
      </tbody>
    </Table>
  );

  const handleDownload = () => {
    downloadCSVFile(visits, "Stops", props.assetCustomerName, timeZone, props.assetId);
  };

  return <ToggleBar caption={`Stops (${visits.length})`} headerContent={props.headerContent} download={handleDownload} icon="fa-map-marker" color="#337ab7" content={data} />;
}

export default VisitNewLog;
